export default __webpack_public_path__ + "static/media/lock.d6896054.svg";